<template>
  <StickyBottomBar>
    <EarlyBirdCouponBanner v-if="currentEarlyBirdCoupon" class="eb-banner" />

    <div class="body">
      <ItineraryPriceAndCta />
    </div>
  </StickyBottomBar>
</template>

<script setup>
import ItineraryPriceAndCta from '@/modules/Itinerary/Components/ItineraryPriceAndCta.vue'
import EarlyBirdCouponBanner from '@/modules/Itinerary/Components/EarlyBirdCouponBanner.vue'
import { useItineraryStore } from '@/stores/itinerary.js'
import StickyBottomBar from '@/components/Theme2/StickyBottomBar.vue'

const {
  data: { currentEarlyBirdCoupon },
} = useItineraryStore()
</script>

<style lang="scss" scoped>
.eb-banner {
  padding-bottom: 24px;
  transform: translateY(12px);
}

.body {
  @include main-wrapper;
  background: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid $gray-lighter;
  padding-block: 24px;
  position: relative;
  z-index: 10;
}

.body:deep(.price) {
  align-items: flex-start;
  gap: 2px;

  .original {
    display: none;
  }
}
</style>
